import React from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import BreadcrumbsMUI from 'common/AbstractBreadcrumbs/BreadcrumbsMUI'
import PageLayout from 'common/Layout/Page/PageLayout'
import { ColorBoxContent } from 'common/ui/colorBox'
import { LocationState } from 'types/routerLocation'

let toggledWarningFromPrevLocation = false

const quotationData = {
  id: '12345',
  preparedData: new Date(),
  orders: [
    {
      orderSummary: 'Pro Plan 1',
      orderDescription: '500GB, unlimited talktime, unlimited SMS',
      price: 50,
      quantity: 100,
      amount: 5000.0
    },
    {
      orderSummary: 'Pro Plan 2',
      orderDescription: '500GB, 1000mins talk time, 2000 SMS',
      price: 18,
      quantity: 100,
      amount: 1800.0
    }
  ]
}

export default function ConfirmQuotation() {
  // to change
  const location = useLocation() as LocationState
  const state = location.state

  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  return (
    <PageLayout header='Purchase Order'>
      <Grid container direction='column' spacing={2}>
        <Grid item>
          <ColorBoxContent variant='white'>
            <BreadcrumbsMUI
              crumbs={[
                {
                  route: '/purchase-order',
                  name: 'Quotation'
                },
                {
                  route: '/confirm-quotation',
                  name: 'View Quotation'
                }
              ]}
            />
          </ColorBoxContent>
        </Grid>
        <Grid item>
          <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
            12345678
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '32px'
            }}
          >
            <Box height='55%'>
              <Box
                sx={{
                  width: '500px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <Typography variant='h4' sx={{ margin: 0 }}>
                  Quotation
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                  01 Dec 2021
                </Typography>
              </Box>
              <Divider sx={{ width: '100%' }} />
              <Table sx={{ width: '100%' }}>
                <TableHead data-align='left'>
                  <TableCell
                    variant='head'
                    style={{
                      width: '40%'
                    }}
                  >
                    Order Summary
                  </TableCell>
                  <TableCell sx={{ width: '20%' }}>Price</TableCell>
                  <TableCell sx={{ width: '20%' }}>Quantity</TableCell>
                  <TableCell sx={{ width: '20%' }}>Amount</TableCell>
                </TableHead>
                <Divider sx={{ width: '255%' }} />
                {quotationData.orders.map((orders, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        {orders.orderSummary}
                        <br />
                        <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                          {orders.orderDescription}
                        </Typography>
                      </TableCell>
                      <TableCell>${orders.price}</TableCell>
                      <TableCell>{orders.quantity}</TableCell>
                      <TableCell>${orders.amount}</TableCell>
                    </TableRow>
                  )
                })}
              </Table>
            </Box>
            <Box
              sx={{
                width: '50%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Box>
                <Typography variant='h4' sx={{ margin: '1' }}>
                  Prepared for:
                </Typography>
                <Divider sx={{ width: '380px' }} />
                <table>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Company Name
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>Company ABC Pte Ltd.</td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Unique Entity Number (UEN)
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>123456789A</td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Contact Person&apos;s Name
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>John Doe</td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Contact Number
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>+65 6234 1234</td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Email
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>johndoe@abc.sg</td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Delivery Address
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      Blk 45, Singapore Street 123 #24-45, Orange Building
                    </td>
                  </tr>
                  <tr data-align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Biiling Address
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      Blk 45, Singapore Street 123 #24-45, Orange Building
                    </td>
                  </tr>
                </table>
              </Box>
            </Box>
          </Box>
          <Box>
            <ColorBoxContent
              variant='primary'
              style={{
                padding: '20px',
                width: '660px',
                minHeight: '37px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <table style={{ width: '100%' }}>
                <tr>
                  <th>
                    <Typography
                      align='left'
                      variant='h6'
                      sx={{ fontSize: '14px', color: '#818D9C' }}
                    >
                      Validity: 01 Jan 2022
                    </Typography>
                  </th>
                  <th align='right'>Total: $6,800</th>
                </tr>
              </table>
            </ColorBoxContent>
            <br />
            <ColorBoxContent
              variant='primary'
              style={{
                padding: 20,
                width: '660px',
                minHeight: '196px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Typography>Terms & Condition</Typography>
              <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
                Terms & Conditions Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Sed facilisis posuere massa, lobortis placerat
                est accumsan eget. Aliquam aliquet dui nec dui maximus
                sollicitudin vel sit amet diam. Curabitur vestibulum pretium
                aliquet. In aliquet urna lectus, non dapibus nulla eleifend ut.
                Pellentesque quis velit nisl. Morbi tristique, ligula in
                fermentum mollis, enim velit gravida quam, elementum tristique
                enim nisi et lacus. Proin eu ligula ut nisl dignissim posuere.
                Ut rutrum a
              </Typography>
              <Divider sx={{ width: '100%' }} />
              <Box
                sx={{
                  display: 'flex',
                  alignItem: 'center'
                }}
              >
                <Checkbox sx={{ color: '#CFD8E3', marginRight: '8px' }} /> I
                agree and accept the quotation price{' '}
              </Box>
            </ColorBoxContent>
          </Box>
          <br />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Button variant='contained'>Approve</Button>
          </Box>
        </Grid>
      </Grid>
    </PageLayout>
  )
}
